<template>
    <a-form
      ref="formRef"
      :model="formState"
      :rules="rules"
      v-if="!isDetail"
      :label-col="{
        span: 2,
      }"
      :wrapper-col="{
        span: 22,
      }"
    >
      <a-form-item ref="title" label="标题" name="title">
        <a-input v-model:value="formState.title" />
      </a-form-item>
      <!-- 富文本 -->
      <a-form-item ref="content" label="通知内容" name="content">
        <div style="border: 1px solid #d9d9d9; border-radius: 2px">
          <Toolbar
            style="border-bottom: 1px solid #d9d9d9"
            :editor="editorRef"
            :defaultConfig="toolbarConfig"
            mode="default"
          />
          <Editor
            :style="{height: '300px', overflowY: 'hidden', pointerEvents: isDetail ? 'none' : 'auto'}"
            v-model="formState.content"
            :defaultConfig="editorConfig"
            mode="default"
            @onCreated="handleCreated"
          />
        </div>
      </a-form-item>
      <a-form-item label="类型" name="type">
        <a-select v-model:value="formState.type" style="width: 250px">
            <a-select-option v-for="item in Object.keys(Enum.noticeType.value)" :key="item" :value="item">
                {{ Enum.noticeType.value[item] }}
            </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item ref="departId" label="目标" name="departIds">
        <a-tree-select
          v-model:value="formState.departIds"
          show-search
          placeholder="请选择目标"
          allow-clear
          tree-default-expand-all
          :tree-data="props.treeData"
          tree-node-filter-prop="name"
          :fieldNames="{ label: 'name', value: 'depart_id' }"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          multiple
          :maxTagCount="3"
        />
      </a-form-item>
      <a-form-item label="发布时间" name="publishTime">
        <a-date-picker
          v-model:value="formState.publishTime"
          show-time
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          placeholder="选择发布时间"
          style="width: 250px"
        />
      </a-form-item>
      <div v-if="!isDetail" style="width: 100%; margin-top: 10px">
        <a-button type="primary" size="large" @click="onSubmit" style="width: 100%">提交</a-button>
      </div>
    </a-form>
    <a-descriptions v-else :column="1" bordered>
      <a-descriptions-item label="标题">{{ formState.title }}</a-descriptions-item>
      <a-descriptions-item label="通知内容">
        <div v-html="formState.content"></div>
      </a-descriptions-item>
      <a-descriptions-item label="附件下载">
        <div v-for="item in fileList" :key="item.id">
          <a
            :href="item.file_url"
            target="_blank"
            :download="`${item.file_name}.${item.file_type}`"
          >{{ item.file_name }}</a>
        </div>
      </a-descriptions-item>
      <a-descriptions-item label="类型">
        {{ Enum.noticeType.value[formState.type] }}
      </a-descriptions-item>
      <a-descriptions-item label="目标" v-if="formState.departList && formState.departList.length > 0">
        {{ formState.departList.map((item) => item.name).join(',')  }}
      </a-descriptions-item>
      <a-descriptions-item label="发布时间">
        {{ formState.publishTime }}
      </a-descriptions-item>
    </a-descriptions>
  </template>
  <script setup>
    import {
      reactive,
      ref,
      toRaw,
      defineProps,
      defineEmits,
      toRefs,
      onBeforeUnmount,
      shallowRef,
    } from 'vue'
    import { message } from 'ant-design-vue'
    import { addNotice, updateNotice, uploadSearch } from '@/api/notice/notice'
    import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
    import '@wangeditor/editor/dist/css/style.css'
    import { useStore } from 'vuex'
  
    const props = defineProps({
      isEdit: Boolean,
      isDetail: Boolean,
      editData: Object,
      treeData: Array,
    })
    const store = useStore()
    const config = toRefs(store.getters['user/config'])
    const Enum = toRefs(store.state.common)
    const emit = defineEmits(['submit'])
    const formRef = ref()
    // 编辑器实例，必须用 shallowRef
    const editorRef = shallowRef()
    const toolbarConfig = {
        uploadImage: {
            disabled: true
        },
        uploadVideo: {
            disabled: true
        }
    }
    const editorConfig = { 
        placeholder: '请输入通知内容...',
    }
    
    const handleCreated = (editor) => {
      editorRef.value = editor
    }
    
    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const defaultFormState = props.isEdit
      ? {
          noticeId: props.editData.notice_id,
          title: props.editData.title,
          content: props.editData.content,
          type: props.editData.type.toString(),
          status: props.editData.status.toString(),
          publishTime: props.editData.publish_time,
          departList: props.editData.departList,
          departIds: props.editData.departList?.map((item) => item.depart_id),
        }
      : {
          title: '',
          content: '',
          type: '',
          status: '',
          publishTime: '',
          departIds: [],
        }

    const fileList = ref([])
    if (props.isDetail) {
      uploadSearch({noticeId: props.editData.notice_id}).then((res) => {
        if (res.code === 1000) {
          fileList.value = [...res.data];
        }
      })
    }

    const formState = reactive(defaultFormState)
    const rules = {
      title: [
        {
          required: true,
          message: '请输入标题',
          trigger: 'blur',
        }
      ],
      publishTime: [
        {
          required: true,
          message: '请选择发布时间',
          trigger: 'blur',
        },
      ],
      type: [
        {
          required: true,
          message: '请选择通知类型',
          trigger: 'blur',
        },
      ],
      status: [
        {
          required: true,
          message: '请选择通知状态',
          trigger: 'blur',
        },
      ],
    }
    async function handelCreate(data) {
      const ajaxFn = props.isEdit ? updateNotice : addNotice
      const messageText = props.isEdit ? '编辑' : '创建'
      const _data = {
        ...data,
        departIds: data.departIds.join(','),
      }
      const res = await ajaxFn(_data)
      if (res.success) {
        message.success(messageText + '通知成功！')
        emit('submit')
      } else {
        message.warn(messageText + '通知错误：', res.message)
      }
    }
    function onSubmit() {
      formRef.value
        .validate()
        .then(() => {
          handelCreate(toRaw(formState))
        })
        .catch((error) => {
          console.log('创建通知错误：', error)
        })
    }
    function resetForm() {
      formRef.value.resetFields()
    }
  </script>
  
<style lang="less">
.ant-form-item {
    margin-bottom: 5px;
}
.w-e-bar > .w-e-bar-item:nth-child(23), .w-e-bar > .w-e-bar-item:nth-child(24) {
    display: none;
}
.ant-descriptions-item-content {
  width: 80%;
}
.ant-descriptions-item-label {
  text-align: center!important;
}
</style>